"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = {
  isPortraitMode: _propTypes["default"].bool,
  activeDesignArea: _propTypes["default"].bool,
  selectedDesignArea: _propTypes["default"].string,
  fatalError: _propTypes["default"].bool,
  children: _propTypes["default"].object,
  showDesigner: _propTypes["default"].bool,
  fallbackMode: _propTypes["default"].bool,
  is3DvisualMode: _propTypes["default"].bool,
  selectedConfigurationMode: _propTypes["default"].string,
  customElements: _propTypes["default"].shape({
    main: _propTypes["default"].node,
    root: _propTypes["default"].node
  }),
  // Render props
  renderVisualization: _propTypes["default"].func,
  renderError: _propTypes["default"].func,
  renderAlertMessages: _propTypes["default"].func,
  renderConfirm: _propTypes["default"].func,
  renderAmountPrice: _propTypes["default"].func,
  renderLandscapeInformation: _propTypes["default"].func,
  renderSaveConfiguration: _propTypes["default"].func,
  renderSendEmail: _propTypes["default"].func,
  renderPdfDownload: _propTypes["default"].func,
  renderLoadConfiguration: _propTypes["default"].func,
  renderLoader: _propTypes["default"].func,
  // Components
  CreatorScreen: _propTypes["default"].elementType.isRequired,
  DesignerScreen: _propTypes["default"].elementType.isRequired,
  VisualizationProvider: _propTypes["default"].elementType.isRequired,
  FallbackVisualization: _propTypes["default"].elementType.isRequired,
  ThemeProvider: _propTypes["default"].elementType.isRequired
};